import * as dayjs from "dayjs";
import { PaymentInterval } from "./simulator/simulator";

export const calculateInstallmentDates = (installmentAmount: number, dueDate: Date, paymentInterval: PaymentInterval): Date[] => {
    const payments = [dueDate];
    let paymentDate: dayjs.Dayjs = dayjs(dueDate);

    for (let currentInstallment = 1; currentInstallment < installmentAmount; currentInstallment++) {
        switch (paymentInterval) {
            case PaymentInterval.Weekly:
                payments.push(paymentDate.add(currentInstallment, 'week').toDate());
                break;

            default:
                // Monthly as default
                payments.push(paymentDate.add(currentInstallment, 'month').toDate());
                break;
        }
    }

    return payments;
}

export const calculateInstallmentsCashFlow = (
    dueDate: Date,
    numberOfInstallments: number,
    paymentInterval: PaymentInterval,
    pmt: number,
    downPaymentPmt: number,
    downPayments: number = 0
): (number | Date)[][] => {
    const totalInstallments = downPayments + numberOfInstallments;
    const installmentInfos: (number | Date)[][] = [];
    let paymentDate: dayjs.Dayjs = dayjs(dueDate);

    for (let currentInstallment = 0; currentInstallment < totalInstallments; currentInstallment++) {
        const amount = currentInstallment >= downPayments
            ? pmt
            : downPaymentPmt;
        
        switch (paymentInterval) {
            case PaymentInterval.Weekly:
                installmentInfos.push([
                    amount,
                    paymentDate.add(currentInstallment, 'week').toDate()
                ]);
                break;

            default:
                // Monthly as default
                installmentInfos.push([
                    amount,
                    paymentDate.add(currentInstallment, 'month').toDate()
                ]);
                break;
        }
    }

    return installmentInfos;   
}

export const convertToInterestFraction = (interestRate: number, paymentInterval: PaymentInterval): number => {
    let interestFactor = interestRate / 100;
    
    switch (paymentInterval) {
        case PaymentInterval.Weekly:
            // convert to yearly
            interestFactor = Math.pow(1 + interestFactor, 12) - 1;

            // convert to weekly
            interestFactor = Math.pow(1 + interestFactor, 1 / 52) - 1;
            return interestFactor;
    
        default:
            // monthly
            return interestFactor;
    }
}
